import React, { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { changeUserCurrency } from "../actions/authActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faGlobeAmericas,
  faCircleDot,
  faMoon,
  faCircleHalfStroke,
} from "@fortawesome/free-solid-svg-icons";

const SettingsPage = ({
  changeUserCurrency,
  userCurrency,
  darkMode,
  setDarkMode,
}) => {
  const { t, i18n } = useTranslation();

  const lngs = ["ka", "en", "ru"]; //  "ru"
  const lngsName = { ka: "ქართული", en: "English", ru: "Русский" };

  return (
    <>
      {/* Language Switcher */}
      <div className="lang-switcher-container-in-settings-page">
        <span className="lang-switcher-title-in-settings-page">
          <FontAwesomeIcon icon={faGlobeAmericas} size="sm" />{" "}
          {t("select your language")}
        </span>

        <div className="lang-switcher-buttons-container-in-settings-page">
          {lngs.map((lng) => {
            // ვამოწმებთ, არის თუ არა ეს კონკრეტული ენა ამჟამად არჩეული
            const isActive = lng === localStorage.getItem("i18nextLng");

            return (
              <div
                key={lng}
                className={`lang-switcher-button-in-settings-page ${isActive ? "active-lang" : ""}`}
                onClick={() => i18n.changeLanguage(lng)}
              >
                {/* თუ ენა აქტიურია, გამოჩნდება Check აიქონი */}
                {/* {isActive && <FontAwesomeIcon icon={faCircleDot} size="2xs" />} */}

                <img src={`/img/${lng}.png`} alt={lngsName[lng]} />
                <span>{lngsName[lng]}</span>
              </div>
            );
          })}
        </div>
      </div>

      {/* Dark Mode Switcher */}
      <div className="dark-mode-switcher-container-in-settings-page">
        <span className="dark-mode-switcher-title-in-settings-page">
          <FontAwesomeIcon icon={faCircleHalfStroke} size="sm" />{" "}
          {t("select theme")}
        </span>

        <div className="dark-mode-switcher-button-in-settings-page">
          <p>{!darkMode ? t("dark_mode_off") : t("dark_mode_on")}</p>

          <button
            className={`ios-switch ${darkMode ? "active" : ""}`}
            onClick={() => {
              setDarkMode(!darkMode);

              if (localStorage.getItem("dark-mode")) {
                localStorage.removeItem("dark-mode");
                setDarkMode("");
              } else {
                localStorage.setItem("dark-mode", "dark-mode");
                setDarkMode("dark-mode");
              }
            }}
          >
            <span className="switch-slider"></span>
          </button>
        </div>
      </div>

      {/* Currency Switcher */}
      <div className="currency-switcher-container-in-settings-page">
        <span className="currency-switcher-title-in-settings-page">
          <FontAwesomeIcon icon={faGlobeAmericas} size="sm" />{" "}
          {t("select your currency")}
        </span>

        <div className="currency-switcher-buttons-container-in-settings-page">
          <button
            className={
              "currency-switcher-button-in-settings-page " +
              (userCurrency === "GEL" ? "active-currency" : "")
            }
            onClick={() => {
              changeUserCurrency("GEL");
            }}
          >
            <input type="radio" />
            <span>{t("GEL")}</span> <span> - ₾</span>
          </button>
          <button
            className={
              "currency-switcher-button-in-settings-page " +
              (userCurrency === "USD" ? "active-currency" : "")
            }
            onClick={() => {
              changeUserCurrency("USD");
            }}
          >
            <input type="radio" />
            <span>{t("USD")}</span>-<span>$</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default SettingsPage;
